module.exports = __webpack_public_path__ + "static/media/remove.6f7ec334.svg";